import { useState } from 'react'
import { AppShell, type AppMode } from '@/components/layout/AppShell'
import { BucketList } from '@/components/buckets/BucketList'
import { JournalView } from '@/components/journal/JournalView'
import { CalendarView } from '@/components/calendar/CalendarView'

export default function App() {
  const [mode, setMode] = useState<AppMode>('detail')

  return (
    <AppShell mode={mode} onModeChange={setMode}>
      {mode === 'detail'   && <BucketList />}
      {mode === 'journal'  && <JournalView />}
      {mode === 'calendar' && <CalendarView />}
    </AppShell>
  )
}
